import {
    Observable,
    combineLatest,
    timer,
    of,
    merge,
    defer,
    Subject,
    race
} from 'rxjs';
import {
    takeUntil,
    mapTo,
    finalize,
    tap,
    take,
    map,
    debounceTime
} from 'rxjs/operators';
import { Guid } from '../guid';
import { LoggingService } from '../../shared/services/logging/logging.service';
import * as fromStore from './store';
import { select, Store } from '@ngrx/store';

const log = new LoggingService();

export function getLoading(
    observables: Observable<any>[],
    store: Store,
    delayTime: number = 100,
    minSpinnerTime: number = 1000
): Observable<boolean> {
    const id = 'getLoading_' + Guid.newGuid();
    // tslint:disable-next-line:no-console
    console.time(id);
    (console as any).timeLog(id);
    return merge(
        of(false),
        timer(delayTime).pipe(
            tap(() => {
                log.verbose({
                    type: id,
                    value: 'loading on after delay',
                    delayTime
                });
                (console as any).timeLog(id);
            }),
            // takeUntil(
            //     combineLatest(observables)
            // ),
            mapTo(true)
        ),
        combineLatest([...(observables || []), timer(minSpinnerTime)]).pipe(
            take(1),
            tap(x => {
                log.verbose({
                    type: id,
                    value: 'loading off after complete and spin time',
                    minSpinnerTime,
                    x
                });
                (console as any).timeLog(id);
            }),
            mapTo(false)
        ),
        store.pipe(
            select(fromStore.getLoading),
            debounceTime(minSpinnerTime),
            map(x => !!x)
        )
    );
}


export function prepare<T>(
    callback: () => void
): (source: Observable<T>) => Observable<T> {
    return (source: Observable<T>): Observable<T> =>
        defer(() => {
            callback();
            return source;
        });
}

export function indicate<T>(
    indicator: Subject<boolean>
): (source: Observable<T>) => Observable<T> {
    return (source: Observable<T>): Observable<T> =>
        source.pipe(
            prepare(() => indicator.next(true)),
            finalize(() => indicator.next(false))
        );
}
